// extracted by mini-css-extract-plugin
export default {"container":"styles_container__h3tkM","componentStack":"styles_componentStack__8yvcy"};